import React from 'react';
export default function DiIconClear(props) {
  return React.createElement(
    'svg',
    {
      viewBox: '0 0 13 13'
    },
    React.createElement(
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd'
      },
      React.createElement('path', {
        d: 'M1.4171948,12.6582216 L6.2499851,7.82581276 L11.0823939,12.6582216 C11.2042732,12.7800627 11.4023318,12.7800627 11.524173,12.6582216 L12.4081888,11.7742057 C12.5300299,11.6523646 12.5300299,11.454306 12.4081888,11.3324267 L7.57577997,6.50001788 L12.4081888,1.66760905 C12.5300299,1.54572977 12.5300299,1.34767116 12.4081888,1.22583002 L11.524173,0.34181418 C11.4023318,0.21997304 11.2042732,0.21997304 11.0823939,0.34181418 L6.2499851,5.17422301 L1.41757627,0.341432711 C1.29569698,0.219553424 1.09763837,0.219553424 0.975797234,0.341432711 L0.0913999286,1.2254104 C-0.0304793585,1.34728969 -0.0304793585,1.5453483 0.0913999286,1.66722758 L4.92419023,6.50001788 L0.0913999286,11.3324267 C-0.0304793585,11.454306 -0.0304793585,11.6523646 0.0913999286,11.7742057 L0.975377618,12.6582216 C1.09725691,12.7800627 1.29531552,12.7800627 1.4171948,12.6582216 Z',
        fill: '#303030',
        fillRule: 'nonzero'
      })
    )
  );
}